export default "__VITE_ASSET__BzpHidIp__"